export const FORM_NAME = 'externalListingClone'

export const PROPOSAL_FIELD = {
  TITLE: 'title',
  SHORT_DESCRIPTION: 'shortDescription',
  COPY: 'copy',
  BRAND: 'brand',
  SPEC: 'spec',
  IMAGES: 'images',
  SPEC_TABLE: 'specTable',
  ATTRIBUTE: 'attribute'
}

export const PROPOSAL_FIELD_MAP = {
  [PROPOSAL_FIELD.TITLE]: '商品名稱',
  [PROPOSAL_FIELD.SHORT_DESCRIPTION]: '商品特色',
  [PROPOSAL_FIELD.COPY]: '商品詳情',
  [PROPOSAL_FIELD.BRAND]: '品牌',
  [PROPOSAL_FIELD.SPEC]: '規格',
  [PROPOSAL_FIELD.IMAGES]: '商品圖',
  [PROPOSAL_FIELD.SPEC_TABLE]: '規格表',
  [PROPOSAL_FIELD.ATTRIBUTE]: '商品屬性'
}

/** Listing schema field paths (Momo/Shopee getDataFromHtml output). Same style as PROPOSAL_FIELD for reuse in getMomoSchema/getShopeeSchema. */
export const SCHEMA = {
  TITLE: 'title',
  BRAND: 'brand',
  ATTRIBUTES_TABLE: 'attributesTable',
  PRODUCT_COPY: 'product.copy',
  SHORT_DESCRIPTION: 'shortDescription',
  PRODUCT_IMAGES: 'productImages',
  PRODUCT_SPECS: 'productSpecs'
}

export const SCHEMA_LABELS = {
  [SCHEMA.TITLE]: '商品名稱',
  [SCHEMA.BRAND]: '品牌',
  [SCHEMA.ATTRIBUTES_TABLE]: '規格表',
  [SCHEMA.PRODUCT_COPY]: '賣場詳情',
  [SCHEMA.SHORT_DESCRIPTION]: '商品特色',
  [SCHEMA.PRODUCT_IMAGES]: '商品圖',
  [SCHEMA.PRODUCT_SPECS]: '規格資訊'
}

/** Label shown in proposal checklist when a field has no data. */
export const CHECKLIST_EMPTY_LABEL = '無資料'

/** Separator used when joining multiple checklist display items (e.g. attributes, specs). */
export const CHECKLIST_DISPLAY_ITEM_SEPARATOR = '／'

/** Separator between label and value in checklist display (e.g. "顏色：紅"). */
export const CHECKLIST_DISPLAY_LABEL_VALUE_SEPARATOR = '：'

/** Separator between multiple values within one spec in checklist display (e.g. "紅|藍"). */
export const CHECKLIST_DISPLAY_SPEC_VALUES_SEPARATOR = '|'

/** Suffix appended to product image URLs to mark them as product images (used by clone flow). */
export const PRODUCT_IMAGE_HASH = '#PRODUCT_IMAGE'

export const PLATFORM_OPTIONS = [
  { label: 'momo', value: 'momo' },
  { label: 'shopee', value: 'shopee' }
]

export const PRODUCT_ATTRIBUTE_OPTIONS = [
  { label: '自動判斷', value: 'auto' },
  { label: '無選項', value: 'none' },
  { label: '有選項', value: 'has' }
]

export const FIELD = {
  PLATFORM: 'platform',
  EXTERNAL_URL: 'externalUrl',
  SUB_STATION_ID: 'subStationId',
  PRODUCT_ATTRIBUTE: 'productAttribute',
  CATEGORY: 'product.struDataAttrClusterId'
}

export const FIELD_LABELS = {
  [FIELD.PLATFORM]: '平台',
  [FIELD.EXTERNAL_URL]: '外部網址',
  [FIELD.SUB_STATION_ID]: '提案站別',
  [FIELD.PRODUCT_ATTRIBUTE]: '商品屬性',
  [FIELD.CATEGORY]: '規格表'
}

export const CAUSE_CODE = {
  EXTERNAL_CLONE_CORS_ERROR: 'EXTERNAL_CLONE_CORS_ERROR',
  EXTERNAL_CLONE_CREATE_PROPOSAL_ERROR: 'EXTERNAL_CLONE_CREATE_PROPOSAL_ERROR',
  EXTERNAL_CLONE_EMPTY_PROPOSAL_ERROR: 'EXTERNAL_CLONE_EMPTY_PROPOSAL_ERROR',
  EXTERNAL_CLONE_FETCH_DATA_ERROR: 'EXTERNAL_CLONE_FETCH_DATA_ERROR',
  EXTERNAL_CLONE_FETCH_MOMO_LISTING_ERROR: 'EXTERNAL_CLONE_FETCH_MOMO_LISTING_ERROR',
  EXTERNAL_CLONE_FETCH_SHOPEE_LISTING_ERROR: 'EXTERNAL_CLONE_FETCH_SHOPEE_LISTING_ERROR',
  EXTERNAL_CLONE_NO_MATCHING_PLATFORM: 'EXTERNAL_CLONE_NO_MATCHING_PLATFORM',
  EXTERNAL_CLONE_OPERATION_ERROR: 'EXTERNAL_CLONE_OPERATION_ERROR',
  EXTERNAL_CLONE_UPLOAD_ERROR: 'EXTERNAL_CLONE_UPLOAD_ERROR',
  EXTERNAL_CLONE_BLOCKED_ERROR: 'EXTERNAL_CLONE_BLOCKED_ERROR'
}

export const CAUSE_CODE_MAP = {
  [CAUSE_CODE.EXTERNAL_CLONE_CORS_ERROR]: '無法存取網站',
  [CAUSE_CODE.EXTERNAL_CLONE_CREATE_PROPOSAL_ERROR]: '產生提案失敗',
  [CAUSE_CODE.EXTERNAL_CLONE_EMPTY_PROPOSAL_ERROR]: '提案資料為空',
  [CAUSE_CODE.EXTERNAL_CLONE_FETCH_DATA_ERROR]: '取得賣場資料失敗',
  [CAUSE_CODE.EXTERNAL_CLONE_FETCH_MOMO_LISTING_ERROR]: '取得momo商品頁面失敗',
  [CAUSE_CODE.EXTERNAL_CLONE_FETCH_SHOPEE_LISTING_ERROR]: '取得shopee商品頁面失敗',
  [CAUSE_CODE.EXTERNAL_CLONE_NO_MATCHING_PLATFORM]: '無對應平台，取得資料失敗',
  [CAUSE_CODE.EXTERNAL_CLONE_OPERATION_ERROR]: '操作失敗',
  [CAUSE_CODE.EXTERNAL_CLONE_UPLOAD_ERROR]: '上傳失敗',
  [CAUSE_CODE.EXTERNAL_CLONE_BLOCKED_ERROR]: '賣場無法查詢，請稍後再嘗試'
}
